import { PropOptionRadio } from '@/models'

const optionsStatus: PropOptionRadio[] = [
    {
        text: 'ACTIVO',
        value: true
    },
    {
        text: 'INACTIVO',
        value: false
    }
]

export {
    optionsStatus
}
